import React from 'react';
import { Twitter, Facebook, Instagram, Youtube, Mail } from 'lucide-react';
import { footerLinks } from '../data/mock';

const Footer = () => {
  return (
    <footer className="bg-slate-900 text-white">
      {/* Main footer */}
      <div className="max-w-7xl mx-auto px-6 py-16">
        <div className="grid md:grid-cols-2 lg:grid-cols-6 gap-12">
          {/* Brand column */}
          <div className="lg:col-span-2">
            <a href="/" className="flex items-center gap-2 mb-6">
              <div className="w-10 h-10 rounded-xl bg-gradient-to-br from-indigo-500 to-purple-600 flex items-center justify-center">
                <span className="text-white font-bold">3</span>
              </div>
              <span className="font-bold text-xl">3strand Cord</span>
            </a>
            <p className="text-slate-400 text-sm leading-relaxed mb-6">
              A three-fold cord is not quickly broken. We&apos;re committed to strengthening your faith through community, resources, and the power of God&apos;s Word.
            </p>
            <div className="flex items-center gap-3">
              <a href="#twitter" className="w-10 h-10 rounded-lg bg-slate-800 flex items-center justify-center hover:bg-slate-700 transition-colors">
                <Twitter className="w-5 h-5 text-slate-400" />
              </a>
              <a href="#facebook" className="w-10 h-10 rounded-lg bg-slate-800 flex items-center justify-center hover:bg-slate-700 transition-colors">
                <Facebook className="w-5 h-5 text-slate-400" />
              </a>
              <a href="#instagram" className="w-10 h-10 rounded-lg bg-slate-800 flex items-center justify-center hover:bg-slate-700 transition-colors">
                <Instagram className="w-5 h-5 text-slate-400" />
              </a>
              <a href="#youtube" className="w-10 h-10 rounded-lg bg-slate-800 flex items-center justify-center hover:bg-slate-700 transition-colors">
                <Youtube className="w-5 h-5 text-slate-400" />
              </a>
            </div>
          </div>

          {/* Ministry links */}
          <div>
            <h4 className="font-semibold text-white mb-4">Ministry</h4>
            <ul className="space-y-3">
              {footerLinks.ministry.map((link) => (
                <li key={link.name}>
                  <a href={link.href} className="text-sm text-slate-400 hover:text-white transition-colors">
                    {link.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Resources links */}
          <div>
            <h4 className="font-semibold text-white mb-4">Resources</h4>
            <ul className="space-y-3">
              {footerLinks.resources.map((link) => (
                <li key={link.name}>
                  <a href={link.href} className="text-sm text-slate-400 hover:text-white transition-colors">
                    {link.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Connect links */}
          <div>
            <h4 className="font-semibold text-white mb-4">Connect</h4>
            <ul className="space-y-3">
              {footerLinks.connect.map((link) => (
                <li key={link.name}>
                  <a href={link.href} className="text-sm text-slate-400 hover:text-white transition-colors">
                    {link.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Newsletter */}
          <div>
            <h4 className="font-semibold text-white mb-4">Stay Updated</h4>
            <p className="text-sm text-slate-400 mb-4">Subscribe to receive updates, teachings, and encouragement.</p>
            <div className="flex gap-2">
              <input
                type="email"
                placeholder="Email"
                className="flex-grow px-4 py-2 bg-slate-800 border border-slate-700 rounded-lg text-sm text-white placeholder-slate-500 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent"
              />
              <button className="px-4 py-2 bg-indigo-600 rounded-lg hover:bg-indigo-700 transition-colors">
                <Mail className="w-5 h-5" />
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom bar */}
      <div className="border-t border-slate-800">
        <div className="max-w-7xl mx-auto px-6 py-6">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4">
            <p className="text-sm text-slate-500">
              © 2025 3strand Cord Ministry. All rights reserved.
            </p>
            <div className="flex items-center gap-6">
              {footerLinks.legal.map((link) => (
                <a key={link.name} href={link.href} className="text-sm text-slate-500 hover:text-slate-300 transition-colors">
                  {link.name}
                </a>
              ))}
            </div>
            <div className="flex items-center gap-2">
              <span className="w-6 h-4 rounded bg-gradient-to-r from-red-500 via-yellow-500 to-green-500" />
              <span className="text-sm text-slate-500">Global Ministry</span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
